import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, UptakeInsightsGetters } from './types';

const _getters = namespaceHelper.removeNamespace(namespace, UptakeInsightsGetters);
export default {
  [_getters.GET_UNIT_UPTAKE_INSIGHTS]: state => {
    return state.unitUptakeInsights;
  },
  [_getters.GET_SHOW_INSIGHTS]: state => {
    return state.showInsights;
  }
};
